var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "#828282",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3H1.5C0.67 3 0 3.67 0 4.5V7.5H2V9.5H8V7.5H10V4.5C10 3.67 9.33 3 8.5 3ZM7 8.5H3V6H7V8.5ZM8.5 5C8.225 5 8 4.775 8 4.5C8 4.225 8.225 4 8.5 4C8.775 4 9 4.225 9 4.5C9 4.775 8.775 5 8.5 5ZM8 0.5H2V2.5H8V0.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.12f3bed222320ae1cb87f52b505ffef2.svg";
export { ForwardRef as ReactComponent };